const readUploadedUsers = (localStorage, key) => {
  const str = localStorage.getItem(key);
  const obj = str ? JSON.parse(str) : {};
  return obj;
};

export default readUploadedUsers;
